import { Component, Input, Output, OnInit, EventEmitter, ViewChild } from '@angular/core';
import { ConstructSectionQuesDirective, ConstructLiDirective, IntializeScrollDirective } from '../../app.taketestdirective';

@Component({
    selector: 'grey-footer',
    templateUrl: 'app.footer.html'
})
export class GreyFooterComponent {
    @Input() SectionDetailsList: any;
    @Input() TestInfo: any;
    @Output() ParentFunctionCall = new EventEmitter();
    FunctionCall(arg1, arg2, arg3) {
        var obj = {
            arg1: arg1,
            arg2: arg2,
            arg3: arg3
        }
        this.ParentFunctionCall.emit(obj);
    }
}


// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/Test/Footers/Grey/app.footer.ts